// Generates links to GitHub Actions pages based on the provided parameters.
// Currently supports generating links for workflow runs
// TODO: Add support for links to specific job logs

export function generateWorkflowRunLink(nwo: string | null, workflowRunId: number | null): string | undefined {
  if (nwo == null || workflowRunId == null || workflowRunId === 0) {
    return undefined
  }

  return `/${nwo}/actions/runs/${workflowRunId}`
}
